import { Directive, Input, OnChanges, SimpleChanges } from '@angular/core';
import { NG_VALIDATORS } from '@angular/forms';
import { BaseValidator } from '@tcm-modules/tcm-core.module';
import mnt from 'moment';
const moment = mnt;

@Directive({
    selector: '[timeLessThan]',
    providers: [{ provide: NG_VALIDATORS, useExisting: TimeLessThanValidatorDirective, multi: true }],
    standalone: false
})
export class TimeLessThanValidatorDirective extends BaseValidator implements OnChanges {

    @Input()
    timeLessThan: { to: string };

    @Input('timeLessThanFieldName')
    fieldName: string;

    constructor() {
        super('timeLessThan');
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.timeLessThan && changes.timeLessThan.isFirstChange()) {
            return;
        }

        this._onChange();
    }

    protected getValidationResult(control: any) {

        if (!control.value || !this.timeLessThan.to)
            return null;

        const from = moment(control.value, 'HH:mm:ss');
        const to = moment(this.timeLessThan.to, 'HH:mm:ss');
        //comment to convert into minutes
        const fromMinutes = from.get('hour') * 60 + from.get('minute');


        const toMinutes = to.get('hour') * 60 + to.get('minute');

        if (fromMinutes < toMinutes) {
            return null;
        }

        return this.buildValidationErrorResult({ fieldName: this.fieldName });
    }
}

